import { pages, reports, reducers } from "./VRCore";
export const ExamplePage = {
    view: pages.ExamplePage,
    reducer: reducers.ExamplePage_reducer,
    reducer_key: "ExamplePage_reducer",
};
export const ResourcePlanner = {
    view: pages.ResourcePlanner,
    reducer: reducers.ResourcePlanner_reducer,
    reducer_key: "ResourcePlanner_reducer",
};
export const EWCCodes = {
    view: pages.EWCCodes_Page,
    reducer: reducers.EWCCodes_reducer,
    reducer_key: "EWCCodes_reducer",
};
export const FileUploader = {
    view: pages.FileUploader,
    reducer: reducers.FileUploader_reducer,
    reducer_key: "FileUploader_reducer",
};
export const WasteDisposalList = {
    view: pages.WasteDisposalSiteList_page,
    reducer: reducers.WasteDisposalSiteList_reducer,
    reducer_key: "WasteDisposalSiteList_reducer",
};
export const WeekPlannerV2 = {
    view: pages.WeekPlannerV2,
    reducer: reducers.WeekPlannerV2_reducer,
    reducer_key: "WeekPlannerV2_reducer",
};
export const ExampleReport = {
    view: reports.ExampleReport,
    reducer: reducers.ExampleReport_reducer,
    reducer_key: "ExampleReport_reducer",
};
export const SecurityConfig = {
    view: pages.SecurityConfigPage,
    reducer: reducers.SecurityConfig_reducer,
    reducer_key: "SecurityConfig_reducer",
};
export const SeatedUsers = {
    view: pages.SeatedUsersPage,
    reducer: reducers.SeatedUsers_reducer,
    reducer_key: "SeatedUsers_reducer",
};
export const Tutorials = {
    view: pages.TutorialsPage,
    reducer: reducers.Tutorials_reducer,
    reducer_key: "Tutorials_reducer",
};
export const AccidentIncidentReport = {
    view: reports.AccidentReportFormReport,
    reducer: reducers.AccidentReportForm_reducer,
    reducer_key: "AccidentReportForm_reducer",
};
export const GardaNotificationReport = {
    view: reports.GardaNotificationReport,
    reducer: reducers.GardaNotification_reducer,
    reducer_key: "GardaNotification_reducer",
};
export const EULAPage = {
    view: pages.EULAPage,
    reducer: reducers.EULA_reducer,
    reducer_key: "EULA_reducer",
};

export const Roster = {
    view: pages.RosterPage,
    reducer: reducers.Roster_reducer,
    reducer_key: "Roster_reducer",
};

export const UserManagerOldVersion = {
    view: pages.UserManagerPage,
    reducer: reducers.UserManager_reducer,
    reducer_key: "UserManager_reducer",
};
export const ProfileEdit = {
    view: pages.ProfileEditPage,
    reducer: reducers.ProfileEdit_reducer,
    reducer_key: "ProfileEdit_reducer",
};
export const Qualifications = {
    view: pages.QualificationsPage,
    reducer: reducers.Qualifications_reducer,
    reducer_key: "Qualifications_reducer",
};
export const Dashboard = {
    view: pages.DashboardPage,
    reducer: reducers.Dashboard_reducer,
    reducer_key: "Dashboard_reducer",
};

export const HolidayRequest = {
    view: pages.HolidayRequestPage,
    reducer: reducers.HolidayRequest_reducer,
    reducer_key: "HolidayRequest_reducer",
};
export const Messenger = {
    view: pages.MessengerPage,
    reducer: reducers.Messenger_reducer,
    reducer_key: "Messenger_reducer",
};
export const UserPerformance = {
    view: pages.UserPerformancePage,
    reducer: reducers.UserPerformancePage_reducer,
    reducer_key: "UserPerformancePage_reducer",
};
export const TimesheetManager = {
    view: pages.TimesheetManagerPage,
    reducer: reducers.TimesheetManagerPage_reducer,
    reducer_key: "TimesheetManagerPage_reducer",
};
export const SubmittedReports = {
    view: pages.SubmittedReportsPage,
    reducer: reducers.SubmittedReports_reducer,
    reducer_key: "SubmittedReports_reducer",
};
export const RequestedTMPlans = {
    view: pages.RequestedTMPlansPage,
    reducer: reducers.RequestedTMPlans_reducer,
    reducer_key: "RequestedTMPlans_reducer",
};
export const VehicleList = {
    view: pages.VehicleListPage,
    reducer: reducers.VehicleList_reducer,
    reducer_key: "VehicleList_reducer",
};
export const MultiDBViewer = {
    view: pages.MultiDBViewerPage,
    reducer: reducers.MultiDBViewer_reducer,
    reducer_key: "MultiDBViewer_reducer",
};
export const Help = {
    view: pages.HelpPage,
    reducer: reducers.Help_reducer,
    reducer_key: "Help_reducer",
};
export const Hsqe = {
    view: pages.HsqePage,
    reducer: reducers.Hsqe_reducer,
    reducer_key: "Hsqe_reducer",
};
export const VehicleChecklistTemplate = {
    view: pages.VehicleChecklistTemplatePage,
    reducer: reducers.VehicleChecklistTemplate_reducer,
    reducer_key: "VehicleChecklistTemplate_reducer",
};
export const HsqeReport = {
    view: pages.HsqeReportPage,
    reducer: reducers.HsqeReport_reducer,
    reducer_key: "HsqeReport_reducer",
};
export const ExcelDownloader = {
    view: pages.ExcelDownloaderPage,
    reducer: reducers.ExcelDownloader_reducer,
    reducer_key: "ExcelDownloader_reducer",
};
export const CompanyAnalytics = {
    view: pages.CompanyAnalyticsPage,
    reducer: reducers.CompanyAnalytics_reducer,
    reducer_key: "CompanyAnalytics_reducer",
};
export const QRList = {
    view: pages.QRManagerPage,
    reducer: reducers.QRList_reducer,
    reducer_key: "QRList_reducer",
};
export const ToolBoxManager = {
    view: pages.ToolBoxManagerPage,
    reducer: reducers.ToolBox_reducer,
    reducer_key: "ToolBox_reducer",
};
export const ToolBoxProfile = {
    view: reports.ToolBoxProfile,
    reducer: reducers.ToolBoxProfile_reducer,
    reducer_key: "ToolBoxProfile_reducer",
};
export const ToolBoxReport = {
    view: reports.ToolBoxReport,
    reducer: reducers.ToolBoxReport_reducer,
    reducer_key: "ToolBoxReport_reducer",
};
export const HD16Inspection = {
    view: reports.HD16InspectionReport,
    reducer: reducers.HD16Inspection_reducer,
    reducer_key: "HD16Inspection_reducer",
};
export const BlockVehicle = {
    view: reports.BlockVehicleReport,
    reducer: reducers.BlockVehicle_reducer,
    reducer_key: "BlockVehicle_reducer",
};
export const SafetySectionInspection = {
    view: reports.SafetySectionInspectionReport,
    reducer: reducers.SafetySectionInspection_reducer,
    reducer_key: "SafetySectionInspection_reducer",
};
export const TTMSiteInspection = {
    view: reports.TTMSiteInspectionReport,
    reducer: reducers.TTMSiteInspection_reducer,
    reducer_key: "TTMSiteInspection_reducer",
};
export const SiteSpecificRiskAssessment = {
    view: reports.SiteSpecificRiskAssessmentReport,
    reducer: reducers.SiteSpecificRiskAssessment_reducer,
    reducer_key: "SiteSpecificRiskAssessment_reducer",
};
export const TrafficCount = {
    view: reports.TrafficCountReport,
    reducer: reducers.TrafficCount_reducer,
    reducer_key: "TrafficCount_reducer",
};
export const VehicleTrailerCheck = {
    view: reports.VehicleTrailerCheckReport,
    reducer: reducers.VehicleTrailerCheck_reducer,
    reducer_key: "VehicleTrailerCheck_reducer",
};
export const VehicleCheckSheet = {
    view: reports.VehicleCheckSheetReport,
    reducer: reducers.VehicleCheckSheet_reducer,
    reducer_key: "VehicleCheckSheet_reducer",
};
export const OperationMaintenance = {
    view: reports.OperationMaintenanceReport,
    reducer: reducers.OperationMaintenance_reducer,
    reducer_key: "OperationMaintenance_reducer",
};
export const JobTemplate = {
    view: pages.JobTemplatePage,
    reducer: reducers.JobTemplate_reducer,
    reducer_key: "JobTemplate_reducer",
};

export const CompanyPolicy = {
    view: pages.CompanyPolicyPage,
    reducer: reducers.CompanyPolicy_reducer,
    reducer_key: "CompanyPolicy_reducer",
};

export const FirebaseSecurityTester = {
    view: pages.FirebaseSecurityTesterPage,
    reducer: false,
    reducer_key: false,
};

export const CreateJobPack = {
    view: pages.CreateJobPackPage,
    reducer: reducers.CreateJobPack_reducer,
    reducer_key: "CreateJobPack_reducer",
};

export const DailyWorkSheetList = {
    view: pages.DailyWorkSheetListPage,
    reducer: reducers.DailyWorkSheetList_reducer,
    reducer_key: "DailyWorkSheetList_reducer",
};

export const SSWPReport = {
    view: reports.SSWP_report,
    reducer: reducers.SSWPReport_reducer,
    reducer_key: "SSWPReport_reducer",
};
export const JobPackEdit = {
    view: reports.JobPackEdit,
    reducer: reducers.JobPackEdit_reducer,
    reducer_key: "JobPackEdit_reducer",
};
export const JobPackProfile = {
    view: reports.JobPackProfileReport,
    reducer: reducers.JobPackProfileReport_reducer,
    reducer_key: "JobPackProfileReport_reducer",
};
export const JobPackList = {
    view: pages.JobPackListPage,
    reducer: reducers.JobPackList_reducer,
    reducer_key: "JobPackList_reducer",
};
export const MasterSSWPFormCreator = {
    view: pages.SSWPConfigCreatorPage,
    reducer: reducers.SSWPConfigCreator_reducer,
    reducer_key: "SSWPConfigCreator_reducer",
};
export const SLGCheckList = {
    view: reports.SLGCheckListReport,
    reducer: reducers.SLGCheckList_reducer,
    reducer_key: "SLGCheckList_reducer",
};
export const SLGSingleBoxCheckList = {
    view: reports.SLGSingleBoxCheckListReport,
    reducer: reducers.SLGSingleBoxCheckList_reducer,
    reducer_key: "SLGSingleBoxCheckList_reducer",
};
export const VehicleChecklist = {
    view: reports.VehicleCheckListReport,
    reducer: reducers.VehicleCheckList_reducer,
    reducer_key: "VehicleCheckList_reducer",
};
export const VehicleChecklistV2 = {
    view: reports.VehicleCheckListV2Report,
    reducer: reducers.VehicleCheckListV2_reducer,
    reducer_key: "VehicleCheckListV2_reducer",
};
export const DailyWorksheet = {
    view: reports.DailyWorksheetReport,
    reducer: reducers.DailyWorksheet_reducer,
    reducer_key: "DailyWorksheet_reducer",
};
export const JcDailyWorkSheet = {
    view: reports.JcDailyWorkSheet_report,
    reducer: reducers.JcDailyWorksheet_reducer,
    reducer_key: "JcDailyWorksheet_reducer",
};
export const DigReport = {
    view: reports.DigReport_report,
    reducer: reducers.DigReport_reducer,
    reducer_key: "DigReport_reducer",
};
export const SLGReport = {
    view: reports.SLGReport_report,
    reducer: reducers.SLGReport_reducer,
    reducer_key: "SLGReport_reducer",
};
export const pdfViewer = {
    view: reports.pdfViewer,
    reducer: reducers.pdfViewer_reducer,
    reducer_key: "pdfViewer_reducer",
};
export const Profile = {
    view: pages.ProfilePage,
    reducer: reducers.Profile_reducer,
    reducer_key: "Profile_reducer",
};
export const QualificationsOverview = {
    view: pages.QualificationsOverviewPage,
    reducer: reducers.QualificationsOverview_reducer,
    reducer_key: "QualificationsOverview_reducer",
};
export const QualificationsManager = {
    view: pages.QualificationsManagerPage,
    reducer: reducers.QualificationsManager_reducer,
    reducer_key: "QualificationsManager_reducer",
};
export const UserManager = {
    view: pages.UserManagerV2Page,
    reducer: reducers.UserManagerV2_reducer,
    reducer_key: "UserManagerV2_reducer",
};
export const UserProfile = {
    view: reports.UserProfilePage,
    reducer: reducers.UserProfile_reducer,
    reducer_key: "UserProfile_reducer",
};
export const DashboardV2 = {
    view: pages.DashboardV2Page,
    reducer: reducers.DashboardV2_reducer,
    reducer_key: "DashboardV2_reducer",
};
export const SubmittedReportsV2 = {
    view: pages.SubmittedReportsV2Page,
    reducer: reducers.SubmittedReportsV2_reducer,
    reducer_key: "SubmittedReportsV2_reducer",
};
export const WeekPlanner = {
    view: pages.WeekPlannerPage,
    reducer: reducers.WeekPlanner_reducer,
    reducer_key: "WeekPlanner_reducer",
};
export const UserManagerV3 = {
    view: pages.UserManagerV3,
    reducer: reducers.UserManagerV3_reducer,
    reducer_key: "UserManagerV3_reducer",
};
export const UserManagerV4 = {
    view: pages.UserManagerV4Page,
    reducer: reducers.UserManagerV4_reducer,
    reducer_key: "UserManagerV4_reducer",
};
export const JobPackManager = {
    view: pages.JobPackManagerPage,
    reducer: reducers.JobPackManager_reducer,
    reducer_key: "JobPackManager_reducer",
};
export const FileManager = {
    view: pages.FileManagerPage,
    reducer: reducers.FileManager_reducer,
    reducer_key: "FileManager_reducer",
};
export const JobPackV2 = {
    view: pages.JobPackV2Page,
    reducer: reducers.JobPackV2_reducer,
    reducer_key: "JobPackV2_reducer",
};
export const TMPlan = {
    view: reports.TMPlanReport,
    reducer: reducers.TMPlan_reducer,
    reducer_key: "TMPlan_reducer",
};
export const Alerts = {
    view: pages.AlertsPage,
    reducer: reducers.AlertsPage_reducer,
    reducer_key: "AlertsPage_reducer",
};
export const JobPackV3 = {
    view: pages.JobPackV3,
    reducer: reducers.JobPackV3_reducer,
    reducer_key: "JobPackV3_reducer",
};
export const HolidayRequestManager = {
    view: pages.HolidayRequestManagerPage,
    reducer: reducers.HolidayRequestManager_reducer,
    reducer_key: "HolidayRequestManager_reducer",
};
export const QualificationsManagerV2 = {
    view: pages.QualificationsManagerV2,
    reducer: reducers.QualificationsManagerV2_reducer,
    reducer_key: "QualificationsManagerV2_reducer",
};
export const PPEInspection = {
    view: reports.PPEInspection_report,
    reducer: reducers.PPEInspection_reducer,
    reducer_key: "PPEInspection_reducer",
};
export const JcVehicleChecklist = {
    view: reports.JcVehicleChecklist_report,
    reducer: reducers.JcVehicleChecklist_reducer,
    reducer_key: "JcVehicleChecklist_reducer",
};

export const CustomReport = {
    view: reports.CustomReport_report,
    reducer: reducers.CustomReport_reducer,
    reducer_key: "CustomReport_reducer",
};

export const WalkaroundReport = {
    view: reports.WalkaroundReport_report,
    reducer: reducers.WalkaroundReport_reducer,
    reducer_key: "WalkaroundReport_reducer",
};

export const CovidReturnToWork = {
    view: reports.CovidReturnToWork_report,
    reducer: reducers.CovidReturnToWork_reducer,
    reducer_key: "CovidReturnToWork_reducer",
};

export const CovidReport = {
    view: reports.CovidReport_report,
    reducer: reducers.CovidReport_reducer,
    reducer_key: "CovidReport_reducer",
};

export const ConfinedSpace = {
    view: reports.ConfinedSpaceReport,
    reducer: reducers.ConfinedSpace_reducer,
    reducer_key: "ConfinedSpace_reducer",
};
export const HealthAndSafety = {
    view: reports.HealthAndSafetyInduction_report,
    reducer: reducers.HealthAndSafetyInduction_reducer,
    reducer_key: "HealthAndSafetyInduction_reducer",
};
export const SiteAudit = {
    view: reports.SiteAudit_report,
    reducer: reducers.SiteAudit_reducer,
    reducer_key: "SiteAudit_reducer",
};
export const IncidentReport = {
    view: reports.IncidentReport,
    reducer: reducers.IncidentReport_reducer,
    reducer_key: "IncidentReport_reducer",
};
export const DWDReport = {
    view: reports.DWDReport_report,
    reducer: reducers.DWDReport_reducer,
    reducer_key: "DWDReport_reducer",
};
export const OfficeInspectionReport = {
    view: reports.OfficeInspectionReport_report,
    reducer: reducers.OfficeInspectionReport_reducer,
    reducer_key: "OfficeInspectionReport_reducer",
};
export const DWEReport = {
    view: reports.DWEReport_report,
    reducer: reducers.DWEReport_reducer,
    reducer_key: "DWEReport_reducer",
};
export const DWRReport = {
    view: reports.DWRReport_report,
    reducer: reducers.DWRReport_reducer,
    reducer_key: "DWRReport_reducer",
};
export const DWIReport = {
    view: reports.DWIReport_report,
    reducer: reducers.DWIReport_reducer,
    reducer_key: "DWIReport_reducer",
};
export const DWMReport = {
    view: reports.DWMReport_report,
    reducer: reducers.DWMReport_reducer,
    reducer_key: "DWMReport_reducer",
};
export const ExaminationReport = {
    view: reports.Examination_report,
    reducer: reducers.Examination_reducer,
    reducer_key: "Examination_reducer",
};
export const ThreeMinuteTrafficCount = {
    view: reports.ThreeMinuteTrafficCount_report,
    reducer: reducers.ThreeMinuteTrafficCount_reducer,
    reducer_key: "ThreeMinuteTrafficCount_reducer",
};
